import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, Layers, Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
import { company, products } from "../data/mock";

export default function Footer() {
  return (
    <footer className="brand-navy-deep text-white pt-14">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 grid grid-cols-1 md:grid-cols-4 gap-10 pb-12">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-md flex items-center justify-center bg-gradient-to-br from-[#2c3e7a] to-[#0d0f1d] shadow-md">
              <Layers className="text-white" size={22} />
            </div>
            <div className="leading-tight">
              <div className="text-[18px] font-extrabold tracking-wide">FOAM SHEET</div>
              <div className="text-[12px] font-semibold tracking-[0.2em] text-brand-red">SUPPLIERS</div>
            </div>
          </div>
          <p className="text-sm text-white/70 leading-relaxed">
            Trusted manufacturer, supplier, wholesaler & trader of premium-quality foam sheets, mattress foams and packaging foams across India.
          </p>
          <div className="flex gap-3 mt-5">
            {[Facebook, Twitter, Linkedin, Instagram].map((Icon, i) => (
              <a key={i} href="#" aria-label="social" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-brand-red hover:border-brand-red transition-colors">
                <Icon size={15} />
              </a>
            ))}
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-base font-semibold mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/" className="hover:text-brand-red transition-colors">Home Page</Link></li>
            <li><Link to="/company-profile" className="hover:text-brand-red transition-colors">Company Profile</Link></li>
            <li><Link to="/products" className="hover:text-brand-red transition-colors">Our Products</Link></li>
            <li><Link to="/contact-us" className="hover:text-brand-red transition-colors">Contact Us</Link></li>
            <li><a href="#quote" className="hover:text-brand-red transition-colors">Request a Quote</a></li>
          </ul>
        </div>

        {/* Top Products */}
        <div>
          <h4 className="text-base font-semibold mb-4">Top Products</h4>
          <ul className="space-y-2 text-sm text-white/70">
            {products.slice(0, 6).map((p) => (
              <li key={p.id}>
                <Link to={`/products/${p.id}`} className="hover:text-brand-red transition-colors">
                  {p.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-base font-semibold mb-4">Reach Us</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex gap-3">
              <MapPin size={16} className="text-brand-red shrink-0 mt-0.5" />
              <span>{company.address}</span>
            </li>
            <li className="flex gap-3">
              <Phone size={16} className="text-brand-red shrink-0 mt-0.5" />
              <a href={`tel:${company.phoneRaw}`} className="hover:text-white">{company.phone}</a>
            </li>
            <li className="flex gap-3">
              <Mail size={16} className="text-brand-red shrink-0 mt-0.5" />
              <a href={`mailto:${company.email}`} className="hover:text-white">{company.email}</a>
            </li>
            <li className="flex gap-3">
              <Clock size={16} className="text-brand-red shrink-0 mt-0.5" />
              <span>{company.workingHours}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <p>© {new Date().getFullYear()} {company.name}. All Rights Reserved.</p>
          <p>Domain: <span className="text-white">{company.domain}</span></p>
        </div>
      </div>
    </footer>
  );
}
